module.exports = __webpack_public_path__ + "img/bb_g3_nose-02.97b6367f.svg";